export class NavigationUtils {
    public static openUrl(url: string): void {
        window.open(url, '_self');
    }

    public static openUrlInNewTab(url: string) {
        window.open(url, '_blank');
    }

    public static getCurrentUrl(): string {
        return window.location.href;
    }
}
